export const primaryGreen = {
  50: '#e6fdf0',
  100: '#b3f0c7',
  200: '#80e29f',
  300: '#4ed678',
  400: '#1dc952',
  500: '#00a731',
  600: '#00902b',
  700: '#007923',
  800: '#00621b',
  900: '#004c14'
};
